import { $fetch, $post } from '@/utils/http'
import { SendEmailCode, VerifyEmailCode, Register, Login } from '@/types/api'

import { Response } from '@/types/request'
// 发送邮箱验证码
export const sendEmailCode = (params:SendEmailCode): Promise<Response> => {
  return $fetch<Response>(`/base/v1/send_email_code`, params)
}
// 验证邮箱验证码
export const verifyEmailCode = (params: VerifyEmailCode): Promise<Response> => {
  return $fetch<Response>(`/base/v1/verify_email_code`, params)
}

// 新用户注册
export const register = (data: Register): Promise<Response> => {
  return $post<Response>(`/base/v1/register`, data)
}

// 登录
export const login = (data: Login): Promise<Response> => {
  return $post<Response>(`/base/v1/login`, data)
}

// 退出登录
export const loginOut = (data: SendEmailCode): Promise<Response> => {
  return $post<Response>(`/base/v1/login_out`, data)
}

// 校验登录态是否仍有效
// 无效时后端返 401，request.ts 拦截器统一清 token 并跳登录页
// （原 /example/v1/health_ping，已移至 base 模块并正名）
export const tokenVerify = (): Promise<Response> => {
  return $fetch<Response>(`/base/v1/token_verify`)
}
